import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  ListItemIcon,
  Typography,
  FormControl,
  MenuItem,
  Select,
  Badge,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LanguageIcon from "@mui/icons-material/Language";
import TranslateIcon from "@mui/icons-material/Translate";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ScienceIcon from "@mui/icons-material/Science";
import DownloadIcon from "@mui/icons-material/Download";
import doctor from "../assets/images/doctor.png";
import { DetailsToMenu } from "../components/Menu/DetailsToMenu.jsx";
import { NotificationContext } from "../components/Notifications/NotificationContext.jsx";

export default function MobileMenuDrawer({ onNavigate }) {
  const { language, handleSelectLanguage, clinicianName, handleLogout } =
    useContext(DetailsToMenu);
  const { unreadCount } = useContext(NotificationContext);
  const { t, i18n } = useTranslation("menu");
  const navigate = useNavigate();

  const handleClickLogout = () => {
    handleLogout();
    localStorage.removeItem("authToken");
    localStorage.removeItem("selectedCitizen");
    localStorage.removeItem("clinician_name");
    localStorage.removeItem("lastRoute");
    localStorage.removeItem("userSelectedId");
    localStorage.removeItem("clinician_id");
    localStorage.removeItem("role");
    localStorage.removeItem("selectedStatisticsOption");
    navigate("/");
  };

  const handleNavClick = () => {
    if (onNavigate) onNavigate();
  };

  return (
    <>
      <Box
        sx={{
          marginTop: 3,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={doctor} width="80px" alt="Doctor" />
        <Typography
          variant="h6"
          fontWeight="500"
          marginTop="5px"
          marginBottom={2}
        >
          {clinicianName}
        </Typography>
      </Box>
      <Divider />
      <List>
        <ListItem key="home" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/home"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary={t("home")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="notifications" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/notifications"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <Badge badgeContent={unreadCount} color="error">
                <NotificationsIcon />
              </Badge>
            </ListItemIcon>
            <ListItemText primary={t("notifications")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="citizens" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/citizens"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary={t("citizens")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="language" disablePadding>
          <ListItemButton
            component="a"
            href="https://www.oncodir.eu/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <ListItemIcon>
              <LanguageIcon />
            </ListItemIcon>
            <ListItemText primary={t("oncodirProject")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="profile" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/profile"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <AccountCircleIcon />
            </ListItemIcon>
            <ListItemText primary={t("profile")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="documentation" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/documentation"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <MenuBookIcon />
            </ListItemIcon>
            <ListItemText primary={t("documentation")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="research-documents" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/research-documents"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <ScienceIcon />
            </ListItemIcon>
            <ListItemText primary={t("researchDocuments")} />
          </ListItemButton>
        </ListItem>
        <ListItem key="export" disablePadding>
          <ListItemButton
            component={RouterLink}
            to="/export"
            onClick={handleNavClick}
          >
            <ListItemIcon>
              <DownloadIcon />
            </ListItemIcon>
            <ListItemText primary={t("export")} />
          </ListItemButton>
        </ListItem>
      </List>
      <Divider />
      <List sx={{ marginTop: 2 }}>
        <ListItem key="languageList" disablePadding>
          <ListItemIcon sx={{ pl: 2 }}>
            <TranslateIcon />
          </ListItemIcon>
          <ListItemText primary={t("language")} />
        </ListItem>
      </List>
      <FormControl
        sx={{ marginLeft: 1, width: 160, alignSelf: "center" }}
        size="small"
      >
        <Select
          labelId="select-language"
          id="select-language-small"
          value={language || (i18n.resolvedLanguage || "en").split("-")[0]}
          onChange={(e) => handleSelectLanguage(e.target.value)}
        >
          <MenuItem value={"en"}>English</MenuItem>
          <MenuItem value={"ro"}>Română</MenuItem>
          <MenuItem value={"lt"}>Lietuvių</MenuItem>
        </Select>
      </FormControl>

      <List sx={{ marginTop: 2 }}>
        <ListItem key="logout" disablePadding>
          <ListItemButton onClick={handleClickLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={t("logout")} />
          </ListItemButton>
        </ListItem>
      </List>

      <Box sx={{ paddingTop: 2, width: "100%", textAlign: "center" }}>
        <Typography variant="subtitle2">Copyright @Oncodir</Typography>
      </Box>
    </>
  );
}
